module.exports = __webpack_public_path__ + "media/img/pages/profile/ckw ger 1-7030f22b598252654dc93d2e3662a176.jpg";